import { MarkdownContent } from './MarkdownContent'

function textValue(value: unknown) {
  return typeof value === 'string' ? value : ''
}

function tagsValue(value: unknown) {
  return Array.isArray(value) ? value.map(textValue).filter(value => value.trim()) : []
}

export function hasMeaningfulAssistantCreation(value: unknown) {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return false
  const creation = value as Record<string, unknown>
  const kind = textValue(creation.kind)
  if (kind === 'outline') return Boolean(textValue(creation.title).trim() || textValue(creation.hook).trim() || textValue(creation.core_content).trim() || textValue(creation.outline_text).trim() || tagsValue(creation.tags).length)
  if (kind === 'script') return Boolean(textValue(creation.title).trim() || textValue(creation.script).trim())
  if (kind === 'topic') return Array.isArray(creation.topics) && creation.topics.length > 0
  return false
}

function CreationSection({ label, value }: { label: string; value: unknown }) {
  const content = textValue(value)
  if (!content.trim()) return null
  return <section className="assistant-creation-section"><b>{label}</b><MarkdownContent text={content} /></section>
}

export function AssistantCreationCard({ creation, compact = false }: { creation: Record<string, unknown>; compact?: boolean }) {
  if (!hasMeaningfulAssistantCreation(creation)) return null
  const kind = textValue(creation.kind)
  if (kind === 'topic') return null
  const isOutline = kind === 'outline'
  const tags = tagsValue(creation.tags)
  return <article className={`assistant-creation-card ${compact ? 'is-compact' : ''}`} aria-label={isOutline ? '视频大纲最终输出' : '视频脚本最终输出'}>
    <header className="assistant-creation-card-head">
      <span className="badge badge-blue">最终输出 · {isOutline ? '视频大纲' : '完整脚本'}</span>
      <i className={isOutline ? 'ri-file-list-3-line' : 'ri-draft-line'} aria-hidden="true" />
    </header>
    {textValue(creation.title) && <h3>{textValue(creation.title)}</h3>}
    {isOutline && tags.length > 0 && <div className="assistant-creation-tags">{tags.map(tag => <span key={tag}>{tag}</span>)}</div>}
    {isOutline ? <>
      <CreationSection label="开场" value={creation.hook} />
      <CreationSection label="核心内容" value={creation.core_content} />
      <CreationSection label="大纲正文" value={creation.outline_text} />
    </> : <CreationSection label="脚本正文" value={creation.script} />}
  </article>
}
